import React, { useEffect, useState } from "react";
import CurrentPlan from "./section/CurrentPlan";
import BillingInvoice from "./section/BillingInvoice";
import SubscriptionPlan from "./section/SubscriptionPlan";
import "./BillingDetails.scss";
import { subscriptionListAPI } from "services/subscription";
import { getFromLocal } from "config/axiosInstance";
import { toastMessage } from "utils/toastMessageHelper";
import { useSearchParams } from "react-router-dom";
import useShimmer from "hooks/useShrimmer";
import SubscriptionCardShrimmer from "shrimmer/Subscription/SubscriptionCardShrimmer";
import { useTranslation } from "react-i18next";

const BillingDetails = () => {
  //*********************** Handle All State **************************//
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get("tapStatus") || "currentPlan";
  const [subscriptionList, setSubscriptionList] = useState([]);
  const [currentSubscriptionDetail, setCurrentSubscriptionDetail] =
    useState(null);

  const { t } = useTranslation();

  // hook handler

  const [showShimmer, setShowShimmer] = useShimmer(SubscriptionCardShrimmer);

  // const [showShimmer, setShowShimmer] = useShimmer();
  // // tap handler function

  const tabHandler = (currentTap) => {
    searchParams.set("tapStatus", currentTap);
    setSearchParams(searchParams);
  };

  //************************ Handle All Function ************************//
  // Function for get subscription list
  const getSubscriptionListHandler = async () => {
    try {
      setShowShimmer(true);
      let sendParamsData = {
        token: getFromLocal(),
      };
      let responseData = await subscriptionListAPI(sendParamsData);
      const { data, message = "", status } = responseData;
      if (status === 200) {
        console.log(data, "data subscription--------->");
        setSubscriptionList(data?.subscriptionPlanList || []);
        setCurrentSubscriptionDetail(data?.planSubscriptionDetail || {});
      } else {
        toastMessage(message, "error", "subscriptionList");
      }
    } catch (err) {
      console.error(err);
    } finally {
      setShowShimmer(false);
    }
  };

  // useEffect for get subscription list
  useEffect(() => {
    getSubscriptionListHandler();
  }, []);

  //*********************** Handle HTML CODE *************************//
  return (
    <div className="billing_details">
      <h3 className="dashboard_title">{t(`BILLING_DETAIL.billingDetail`)}</h3>
      <div className="tab_wrap">
        <ul>
          <li key={"currentPlan"}>
            <button
              type=""
              onClick={() => tabHandler("currentPlan")}
              className={tab === "currentPlan" ? "active" : ""}
            >
              {t(`BILLING_DETAIL.currentPlan`)}
            </button>
          </li>
          <li key={"Subscription"}>
            <button
              type=""
              onClick={() => tabHandler("Subscription")}
              className={tab === "Subscription" ? "active" : ""}
            >
              {t(`BILLING_DETAIL.subscription`)}
            </button>
          </li>
          <li key={"Invoices"}>
            <button
              type=""
              onClick={() => tabHandler("Invoices")}
              className={tab === "Invoices" ? "active" : ""}
            >
              {t(`BILLING_DETAIL.invoices`)}
            </button>
          </li>
        </ul>
      </div>

      <div className="tab_content">
        {tab === "currentPlan" && (
          <CurrentPlan
            currentSubscriptionDetail={currentSubscriptionDetail}
            showShimmer={showShimmer}
            getSubscriptionListHandler={getSubscriptionListHandler}
          />
        )}
        {tab === "Subscription" && (
          <SubscriptionPlan
            planListing={subscriptionList}
            currentSubscriptionDetail={currentSubscriptionDetail}
            showShimmer={showShimmer}
          />
        )}
        {tab === "Invoices" && <BillingInvoice />}
      </div>
    </div>
  );
};

export default BillingDetails;
